import { NgModule } from '@angular/core';
import { LibWarningOutlineIconComponent } from './lib-warning-outline-icon.component';

@NgModule({
  declarations: [LibWarningOutlineIconComponent],
  imports: [],
  exports: [LibWarningOutlineIconComponent],
})
export class LibWarningOutlineIconModule {}
